import {isUnitFaction} from "../isUnitFaction";
import {FACTIONS} from "../../../constants/factions";
import UNIT_TYPES from "../../../configs/units";

export const checkIfUnitMeleeElf = (unit) => {
  return isUnitFaction(unit, FACTIONS.ELVES) && unit.type !== UNIT_TYPES.D4.id;
}